import { Injector, Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { tap, catchError, switchMap, map, finalize } from 'rxjs/operators';
import { Router } from '@angular/router';
import { FormDataService } from '../Services/Form Data/form-data.service';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus } from '@azure/msal-browser';
import { FormSubmitService } from '../Services/Form Data/formsubmit.service';
import { DataService } from '../Services/Data Service/data.service';
import { format, toZonedTime } from 'date-fns-tz';
import { environment } from '../../environments/environment';
import { isAdminRole } from '../roles';




@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private loginUrl = `${environment.apiBaseUrl}/v1/auth/authenticate`;
  private refreshTokenUrl = `${environment.apiBaseUrl}/v1/auth/refresh-token`;
  private register = `${environment.apiBaseUrl}/user/save`;
  private baseAuthUrl = `${environment.apiBaseUrl}/v1/entra-login`;
  private baseUrl = environment.apiBaseUrl;

  constructor(
    private http: HttpClient, 
    private router: Router, 
    private msalService: MsalService, 
    private formDataService: FormDataService,
    private msalBroadcastService: MsalBroadcastService,
    private formSubmitService: FormSubmitService,
    private injector: Injector
  ) {}

  /** Resolve DataService lazily to avoid circular dependency (AuthService ↔ DataService). */
  private get dataService(): DataService {
    return this.injector.get(DataService);
  }
  
 

  varEmail: any;
  varToken: any;
  varEntraToken:any
  loading= false;

  private getAuthHeaders(): HttpHeaders {
    const accessToken = this.getAccessToken();  
    if (!accessToken) {
        throw new Error('No access token found');
    }
    return new HttpHeaders({
        'Authorization': `Bearer ${accessToken.trim()}`,
    });
  }

  getLocalDate(): string {
    const timeZone = 'America/Port_of_Spain'; // or use Intl.DateTimeFormat().resolvedOptions().timeZone
    const now = new Date();
    const localNow = toZonedTime(now, timeZone);

    const formatted = format(localNow, 'yyyy-MM-dd', { timeZone });
    return formatted;
  }

  formattedDate = this.getLocalDate();

  // Login method
  login(username: string, password: string): Observable<any> {
    return this.http.post(this.loginUrl, { strEmail: username, strPassword: password }).pipe(
      tap((response: any) => {
        if (response && response.accessToken && response.refreshToken) {
          this.storeCredentials(username, response.accessToken, response.refreshToken);
          this.setAccessToken(response.accessToken);
          console.log(response)
          console.log(username)
          console.log(password)
        }
      }),
      switchMap((response: any) => {
        
        const headers = this.getAuthHeaders();
        return this.http.get<any[]>(`${this.baseUrl}/user`, { headers }).pipe(
          map(users => {
            const foundUser = users.find(user => user.strEmail === username);
            if (foundUser) {
              this.storeRole(foundUser?.role);
              return { ...response, user: foundUser }; // ✅ Return full response with user
            } else {
              throw new Error('User not found');
            }
            console.log()
          })
        );
      })
    );
  }  
  loginEntra() {
    // Step 1: Ensure all MSAL accounts are removed (logout)
    const accounts = this.msalService.instance.getAllAccounts();

  // Clear active account
  this.msalService.instance.setActiveAccount(null);

  // Remove all cached accounts from MSAL (app logout)
  accounts.forEach(account => {
    this.msalService.instance.logout({
      account: account,
      postLogoutRedirectUri: '', // Leave empty to avoid navigation
    }).catch(error => {
      // logoutSilent may fail if there's no valid session — just clear account
      console.warn('Silent logout failed:', error);
    
    })});
  
    // Step 2: Force login prompt
    this.msalService.loginPopup({
      scopes: ['user.read'],
      prompt: 'login' // forces reauthentication even if a session exists
    }).subscribe({
      next: (loginResponse) => {
        this.msalService.instance.setActiveAccount(loginResponse.account);
        this.varEntraToken = loginResponse.idToken;
        if (this.varEntraToken) {
          this.sendEntraToken();
        }
      },
      error: (loginError) => {
        console.error('Popup login failed:', loginError);
      }
    });
  }
  sendEntraToken() {
    const payload = this.varEntraToken;
    const url = this.baseAuthUrl;
    this.loading = true;
  
    this.http.post<any>(url, { entraToken: payload }).pipe(
      switchMap((response) => {
        console.log('API response:', response);
  
        if (!response) {
          return throwError(() => new Error('Empty response from API'));
        }
  
        const jwtToken = response;
        sessionStorage.setItem('jwt', JSON.stringify(jwtToken));
  
        const email = jwtToken.email;
        const name = jwtToken.name;
        const username = jwtToken.email;
        const accessToken = jwtToken.token;
        const refreshToken = jwtToken.refreshToken;
  
        const user = {
          dteCreated: this.formattedDate,
          role: 'Admin',
          intCompanyFK: 1,
          strAccountStatus: 'Microsoft Active',
          strAccountStatusDate: this.formattedDate,
          strJobTitle: 'Procurement',
          strContact: '',
          strEmail: email,
          strName: name,
          strPassword: 'ghchgcgfdsfr5GHFCHGDGT',
          signatureFile: null
        };
  
        this.storeCredentials(username, accessToken, refreshToken);
        this.setAccessToken(accessToken);
  
        if (email && accessToken) {
          return this.http.get<any>(`${this.baseUrl}/user/lookup?email=${email}`).pipe(
            catchError((err) => {
              if (err.status === 404) {
                // User not found -> register
                const userJson = encodeURIComponent(JSON.stringify(user));
                return this.http.post(
                  `${this.baseUrl}/user/save?user=${userJson}`,
                  null,
                  { responseType: 'text' as const }
                ).pipe(
                  switchMap(() =>
                    this.http.get<any>(`${this.baseUrl}/user/lookup?email=${email}`)
                  )
                );
              }
              return throwError(() => err);
            }),
            switchMap((foundUser) => {
              if (!foundUser) {
                return throwError(() => new Error('User lookup failed'));
              }
              this.storeRole(foundUser.role);
              this.dataService.setCurrentUser(foundUser);
              return this.VerifyToken().pipe(
                tap(() => this.routeByRole(foundUser.role))
              );
            })
          );
        }
  
        return throwError(() => new Error('Missing email or accessToken'));
      }),
      catchError((err) => {
        console.error('sendEntraToken error:', err);
        this.loading = false;
        return throwError(() => err);
      })
    ).subscribe({
      next: () => {
        this.loading = false;
      },
      error: (err) => {
        console.error('Final error in subscription:', err);
        this.loading = false;
      }
    });
  }
  
  /** Helper to route users by role */
  private routeByRole(role: string) {
    if (isAdminRole(role)) {
      this.router.navigate(['/dashboard']);
    } else if (role === 'Vendor') {
      this.router.navigate(['/registrationform']);
    } else if (role === 'Guest') {
      this.router.navigate(['/start']);
    } else {
      console.warn('Unknown role:', role);
    }
  }
  
          
      

  entraToken: any;

  VerifyToken(): Observable<any> {
    const payload = this.varEntraToken;
    const url = this.baseAuthUrl;
    this.loading = true;
  
    return this.http.post<any>(url, { entraToken: payload }).pipe(
      tap((response) => {
        console.log('API response:', response);
  
        if (response) {
          const jwtToken = response;
          sessionStorage.setItem('jwt', JSON.stringify(jwtToken));
  
          const email = jwtToken.email;
          const accessToken = jwtToken.token;
          const refreshToken = jwtToken.refreshToken;
  
          this.storeCredentials(email, accessToken, refreshToken);
          this.setAccessToken(accessToken);
        }
      }),
      catchError((error) => {
        console.error('Auth error:', error);
        this.loading = false;
        return throwError(() => error);
      }),
      finalize(() => {
        this.loading = false; // ensure loading is false after completion
      })
    );
  }
  





  storeCredentials(email: string, accessToken: string, refreshToken: string) {
    this.varEmail = email;
    this.varToken = accessToken;
    this.setAccessToken(accessToken);
    this.setRefreshToken(refreshToken);
    this.setUserEmail(email);
  }

  storeRole(role: string){
    localStorage.setItem('role', role);
  }

  setAccessToken(token: string) {
    localStorage.setItem('accessToken', token);
  }

  setUserEmail(email: string): void {
    if (typeof window !== 'undefined' && localStorage) {
      localStorage.setItem('userEmail', email);
    }
  }
  
  getUserEmail(): string | null {
    if (typeof window !== 'undefined' && localStorage) {
      return localStorage.getItem('userEmail');
    }
    return null;
  }
  
  getAccessToken(): string | null {
    if (typeof window !== 'undefined' && localStorage) {
      return localStorage.getItem('accessToken') || '';
    }
    return null;
  }


  setRefreshToken(token: string) {
    localStorage.setItem('refreshToken', token);
  }

  getRefreshToken(): string | null {
    if (typeof window !== 'undefined' && localStorage) {
      return localStorage.getItem('refreshToken') || '';
    }
    return null;
  }

  isLoggedIn(): boolean {
    return this.getAccessToken() !== null;
  }

  refreshToken(): Observable<any> {
    const refreshToken = this.getRefreshToken(); 
    if (!refreshToken) {
      return throwError(() => new Error('No refresh token found'));
    }
    return this.http.post(this.refreshTokenUrl, { refreshToken }).pipe(
      tap((response: any) => {
        if (response && response.accessToken) {
          this.setAccessToken(response.accessToken);
        }
      }),
      catchError((error) => {
        console.error('Refresh token failed', error);
        return throwError(() => error);
      })
    );
  }
  

  isTokenExpired(token: string): boolean {
    if (!token) return true;
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp < Date.now() / 1000;
  }

  handleTokenExpiration(): Observable<string> {
    const accessToken = this.getAccessToken();
    
    if (accessToken && !this.isTokenExpired(accessToken)) {
      // If token is valid, return it immediately
      return of(accessToken);
    }
  
    console.log('Access token expired. Refreshing token...');
    
    return this.refreshToken().pipe(
      switchMap((response: any) => {
        if (response && response.accessToken) {
          console.log('New access token:', response.accessToken);
          this.setAccessToken(response.accessToken);
          return of(response.accessToken);
        } else {
          console.error('Invalid refresh response:', response);
          return throwError(() => new Error('Failed to refresh access token'));
        }
      }),
      catchError((error) => {
        console.error('Token refresh failed:', error);
        // Don't force navigation here; callers (guard/interceptor/components) decide UX + routing.
        return throwError(() => new Error('Failed to refresh access token: ' + error?.message));
      })
    );
  }
  
  
  logout(): void {
    // Remove tokens and user info
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('userEmail');
    localStorage.removeItem('role');

    // Clear shared current user so next login gets a fresh fetch
    this.dataService.setCurrentUser(null);

    // Clear observables and form data
    this.formDataService.resetFormData();

    // Redirect to home page
    this.router.navigate(['/']);
  }
  

  checkEmail(email: string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/user/lookup`, {
      params: { email }
    }).pipe(
      map((res) => ({ user: res })),
      catchError((error) => {
        if (error.status === 404) {
          return of({ user: null }); // User not found
        }
        return throwError(() => error);
        // return of({ user: null }); // Safe fallback
      })
    );
  }
  
  
}

